export default __webpack_public_path__ + "static/media/ford.bdbeae8e.png";